// src/utils/SSEManager.js
import { getServerSentEventPath } from '../storage';

let eventSource = null;

export const startSSEConnection = ({
  receiverId,
  onOpen,
  onMessage,
  onError,
}) => {
  if (eventSource) return; // prevent multiple instances

  eventSource = new EventSource(
    `${getServerSentEventPath()}?receiverId=${receiverId}`
  );

  eventSource.onopen = () => {
    console.log('SSE connected');
    onOpen?.();
  };

  eventSource.onmessage = (event) => {
    const data = event.data.toString();
    console.log('[SSE] Message received:', data);

    try {
      onMessage?.(data); // Send raw data to component
    } catch (err) {
      console.error('[SSE] Error in onMessage callback:', err);
    }
  };

  eventSource.onerror = (event) => {
    const target = event?.target;

    console.error('[SSE] Error in EventSource:', event);
    console.error('[SSE] Error target:', target);
    console.error('[SSE] readyState:', target?.readyState);

    switch (target?.readyState) {
      case EventSource.CONNECTING:
        console.error('[SSE] Connection is reconnecting...');
        break;
      case EventSource.OPEN:
        console.error('[SSE] The connection was unexpectedly closed.');
        break;
      case EventSource.CLOSED:
        console.error('[SSE] The connection has been closed.');
        break;
      default:
        console.error('[SSE] Unknown readyState.');
    }

    onError?.(event); // allow context to update state
  };

  window.addEventListener('beforeunload', closeSSEConnection);
};

export const closeSSEConnection = () => {
  if (eventSource) {
    eventSource.close();
    eventSource = null;
    console.log('SSE closed');
  }
  window.removeEventListener('beforeunload', closeSSEConnection);
};
